import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomInputTextArea,
  CustomModal,
  CustomPanel,
  DateTime,
  Loading,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  aprovarOrdemColeta,
  downloadNfDevolucaoParcial,
  downloadNfDevolucaoTotal,
  getOrdensColetasParaAprovacao,
  solicitarCorrecaoOrdemColeta,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'

function AprovacaoOrdemColeta({ dispatch, history }) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [ordens, setOrdens] = useState([])
  const [selectedOrdem, setSelectedOrdem] = useState(null)
  const [showModalAprovacao, setShowModalAprovacao] = useState(false)
  const [showModalCorrecao, setShowModalCorrecao] = useState(false)
  useEffect(() => {
    getOrdemParaAprovacao()
  }, [])

  // Events
  const onMenuItemClick = async (item, ordem) => {
    try {
      switch (item) {
        case 'NFs Devolução Total':
          // Download da NF de Dev Total (zip)
          await downloadNfDevolucaoTotal(ordem.ordemcoleta_id)
          break
        case 'NFs Devolução Parcial':
          await downloadNfDevolucaoParcial(ordem.ordemcoleta_id)
          break
        case 'Visualizar':
          history.push('/main/ordemcoleta/visualizar', {
            ordem: {
              id: ordem.ordemcoleta_id,
              descricao: ordem.ordemcoleta_nome,
            },
          })
          break
        case 'Aprovar':
          setSelectedOrdem(ordem)
          setShowModalAprovacao(true)
          break
        case 'Correção':
          setSelectedOrdem(ordem)
          setShowModalCorrecao(true)
          break
        default:
          break
      }
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onModalAprovacaoCancelarClick = () => {
    setShowModalAprovacao(false)
  }

  const onModalAprovacaoOkClick = async () => {
    try {
      const { ordemcoleta_id } = selectedOrdem
      await aprovarOrdemColeta(ordemcoleta_id)
      await getOrdemParaAprovacao()
      setShowModalAprovacao(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const onModalCorrecaoClose = () => {
    setShowModalCorrecao(false)
  }

  const onModalCorrecaoSuccess = async () => {
    await getOrdemParaAprovacao()
    setShowModalCorrecao(false)
  }

  const onModalCorrecaoError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalCorrecao(false)
  }

  // Helpers
  const getOrdemParaAprovacao = async () => {
    try {
      !isLoading && setIsLoading(true)
      const fetchedOrdens = await getOrdensColetasParaAprovacao()
      setOrdens(fetchedOrdens)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Renders
  return (
    <React.Fragment>
      <PageHeader>
        <strong>Aprovação</strong>&nbsp; - Ordem Coleta
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <OrdensDataTable onMenuItemClick={onMenuItemClick} ordens={ordens} />
          )}
        </CustomPanel>
        <ConfirmDialog
          isVisible={showModalAprovacao}
          content={`Confirma a Aprovação da Ordem de Coleta: ${selectedOrdem ? selectedOrdem.ordemcoleta_nome : ''}?`}
          title="Atenção"
          onCancelar={onModalAprovacaoCancelarClick}
          onOk={onModalAprovacaoOkClick}
        />
        <ModalCorrecao
          isVisible={showModalCorrecao}
          ordemId={selectedOrdem ? selectedOrdem.ordemcoleta_id : null}
          justificativaCorrecao={
            selectedOrdem && selectedOrdem.justificativa_correcao
              ? selectedOrdem.justificativa_correcao
              : ''
          }
          onClose={onModalCorrecaoClose}
          onSuccess={onModalCorrecaoSuccess}
          onError={onModalCorrecaoError}
        />
      </div>
    </React.Fragment>
  )
}

function OrdensDataTable({ ordens, onMenuItemClick }) {
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <DataTable
      value={ordens}
      emptyMessage="Não existe Ordem de Coleta para Aprovação"
      header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
      globalFilter={globalFilter}
    >
      <Column
        field="data_finalizacao"
        header="Dt. Finalizacao"
        style={tableCellCentered(130)}
        body={ordem => <DateTime>{ordem.data_finalizacao}</DateTime>}
      />
      <Column field="ordemcoleta_id" header="Código" style={tableCellCentered(80)} />
      <Column field="ordemcoleta_nome" header="Ordem Coleta" />
      <Column field="empresa" header="Empresa" />
      <Column field="tp" header="Op. Logístico" />
      <Column
        header="Menu"
        style={tableCellCentered(80)}
        body={ordem => (
          <ThreeDots
            items={[
              'Visualizar',
              'NFs Devolução Total',
              'NFs Devolução Parcial',
              'Aprovar',
              'Correção',
            ]}
            onClick={item => onMenuItemClick(item, ordem)}
          />
        )}
      />
    </DataTable>
  )
}

function ModalCorrecao({ justificativaCorrecao, ordemId, isVisible, onClose, onSuccess, onError }) {
  // Hooks
  const [justificativa, setJustificativa] = useState(justificativaCorrecao)
  useEffect(() => {
    setJustificativa(justificativaCorrecao)
  }, [justificativaCorrecao])

  // Events
  const onBtnSalvarClick = async () => {
    try {
      await solicitarCorrecaoOrdemColeta(ordemId, justificativa)
      onSuccess()
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  // Render
  return (
    <CustomModal isVisible={isVisible} header="Justificativa - Correção" onClose={onClose}>
      <div className="p-grid">
        <div className="p-col-12">
          <CustomInputTextArea
            label="Justifique o Motivo da Correção"
            marginTop={0}
            value={justificativa}
            onChange={value => setJustificativa(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClick}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(withRouter(AprovacaoOrdemColeta))
